import { __rest, __assign } from 'tslib';
import * as React from 'react';

function IconBlood(_a) {
    _a.primary; var secondary = _a.secondary, circleStroke = _a.circleStroke, circleFill = _a.circleFill, iconFace = _a.iconFace, props = __rest(_a, ["primary", "secondary", "circleStroke", "circleFill", "iconFace"]);
    return (React.createElement("svg", __assign({ width: 80, height: 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("circle", { cx: 40, cy: 40, r: 39.125, stroke: circleStroke, strokeWidth: 1.75, fill: circleFill }),
        React.createElement("path", { d: "M45 21S32 34.595 32 43.5C32 50.956 37.822 57 45 57s13-6.044 13-13.5C58 34.765 45 21 45 21z", fill: secondary }),
        React.createElement("path", { d: "M40 21.06S26 35.41 26 44.81c0 7.87 6.27 14.25 14 14.25s14-6.38 14-14.25c0-9.22-14-23.75-14-23.75z", stroke: iconFace, strokeWidth: 1.75, strokeMiterlimit: 10 })));
}

export { IconBlood as default };
//# sourceMappingURL=icon-blood-md.esm.js.map
